import { useCallback, useContext, useMemo } from "react";
import { MenuItem } from "@chakra-ui/react";

import { NostrEvent } from "../../types/nostr-event";
import { ExternalLinkIcon } from "../icons";
import { AppHandlerContext } from "../../providers/route/app-handler-provider";
import relayHintService from "../../services/event-relay-hint";

export default function OpenInAppMenuItem({ event }: { event: NostrEvent }) {
  const address = useMemo(() => relayHintService.getSharableEventAddress(event), [event]);
  const { openAddress } = useContext(AppHandlerContext);
  const open = useCallback(() => address && openAddress(address), [address, openAddress]);

  if (!address) return null;
  return (
    <MenuItem icon={<ExternalLinkIcon />} onClick={open}>
      View in app...
    </MenuItem>
  );
}
